import { Injectable } from '@angular/core';
import { ConfigurationHelper } from '../helper/configuration.helper';
import { Logger } from '../logging/default-log.service';
import { ApplicationService } from './application.service';
import { BaseService } from './base.service';
import { HttpClient } from './http.service';

@Injectable()
export class PlantscapingService extends BaseService {
  readonly WEBSITE_PLANTSCAPING_URL_ENDPOINT: string = '/app/plantscaping';

  readonly WEBSHOP_PLANTSCAPING_URL_ENDPOINT: string = '/public/plantscaping';

  readonly WEBSITE_HAS_PLANTSCAPING_URL_ENDPOINT: string =
    '/app/hasplantscaping';

  readonly WEBSHOP_HAS_PLANTSCAPING_URL_ENDPOINT: string =
    '/public/hasplantscaping';

  private readonly TRACK_PLANTSCAPING: string = 'track_plantscaping';

  constructor(
    private applicationService: ApplicationService,
    private http: HttpClient,
    logger: Logger
  ) {
    super(logger);
  }

  /**
   * The plantscaping Url for the noviflora site points to a cms page, which redirects you to the store if this is a page you are allowed to see.
   * The kvk shops do not have a site/cms so the link points you directly to the store.
   * @param isKvk
   */
  public getPlantscapingUrl(isKvk: boolean): Promise<string | void> {
    let plantscapingUrl: URL;

    if (isKvk) {
      plantscapingUrl = new URL(ConfigurationHelper.getWebshopUrl(`/${this.applicationService.getWebsiteLanguage()}/products`));
      plantscapingUrl.searchParams.append('plantscaping', '1');
      return Promise.resolve(plantscapingUrl.href);
    } if (
      this.applicationService.isBrowsingWebsite(window.location.href)
    ) {
      plantscapingUrl = new URL(`${ConfigurationHelper.getWebsiteUrl(this.WEBSITE_PLANTSCAPING_URL_ENDPOINT)}`);
      plantscapingUrl.searchParams.append('allowPlantscaping', 'true');
      plantscapingUrl.searchParams.append(
        'isoLang',
        this.applicationService.getWebsiteLanguage()
      );
    } else {
      plantscapingUrl = new URL(ConfigurationHelper.getWebshopUrl(`${this.WEBSHOP_PLANTSCAPING_URL_ENDPOINT}`));
    }

    return this.http
      .getText(plantscapingUrl.href, false)
      .toPromise()
      .catch(() => this.logger.warn('Could not find plantscaping url'));
  }

  public hasPlantscapingPageAndIsActive(): Promise<string | void> {
    let plantscapingUrl: URL = new URL(ConfigurationHelper.getWebshopUrl(`${this.WEBSHOP_HAS_PLANTSCAPING_URL_ENDPOINT}`));

    if (this.applicationService.isBrowsingWebsite(window.location.href)) {
      plantscapingUrl = new URL(`${ConfigurationHelper.getWebsiteUrl(this.WEBSITE_HAS_PLANTSCAPING_URL_ENDPOINT)}`);
    }

    return this.http
      .getText(plantscapingUrl.href, false)
      .toPromise()
      .catch(() => this.logger.warn('Could not find plantscaping url'));
  }

  // If this is a set to true (1) relevant requests send a tracking variable to Navision.
  public setPlantscapingInSession(shouldBeTracked: number) {
    const trackPlantscaping = shouldBeTracked === 0 ? 'false' : 'true';
    sessionStorage.setItem(this.TRACK_PLANTSCAPING, trackPlantscaping);
  }

  public getPlantscapingFromSession(): boolean {
    const trackPlantscaping = sessionStorage.getItem(this.TRACK_PLANTSCAPING);
    return trackPlantscaping === 'true';
  }
}
